export default {
  disclaimer: {
    summary:
      'Vă rugăm să rețineți că este responsabilitatea dvs. să confirmați că moneda și taxele sunt corecte pentru jurisdicția aplicabilă.',
    extra:
      'Includem aceste informații exclusiv pentru comoditatea dvs. și nu ne asumăm nicio responsabilitate pentru acuratețea monedei și/sau a taxelor ori pentru plata acestora ca parte a produselor noastre. Informațiile privind moneda și taxele sunt furnizate exclusiv în scop informativ.',
    show_more: 'Afișați mai mult',
    show_less: 'Afișați mai puțin',
  },
  partner_note:
    'Acestea sunt valorile implicite la nivel de partener. Restaurantele din contul dvs. le moștenesc automat, dacă nu suprascriu o categorie individual.',
  section_title: 'Cote de taxă pentru articolele din meniu',
  new_category_placeholder: 'Categorie nouă',
  form: {
    name: {
      label: 'Categorie fiscală',
    },
    default_tax_rate: {
      label: 'Cotă implicită',
      tooltip:
        'Utilizată ca valoare implicită când o cotă specifică pentru metoda de comandă de mai jos este lăsată goală.',
    },
    pickup_tax_rate: {
      label: 'Ridicare',
    },
    delivery_tax_rate: {
      label: 'Livrare',
    },
    dine_in_tax_rate: {
      label: 'La restaurant',
    },
    room_service_tax_rate: {
      label: 'Room service',
    },
    show_zero_tax_in_summary: {
      label: 'Afișați taxa 0% în rezumatul comenzii',
    },
  },
  buttons: {
    add_category: 'Adăugați o categorie fiscală',
    cancel: 'Anulați',
    save: 'Salvați',
    confirm: 'Ștergeți',
    delete: 'Ștergeți categoria',
    reset: 'Revenire la moștenit',
  },
  delete_confirm: {
    title: 'Ștergeți această categorie fiscală?',
    description: 'Această acțiune nu poate fi anulată.',
  },
  scope_labels: {
    region: 'La nivel de regiune',
    partner: 'La nivel de partener',
    restaurant: 'La nivel de restaurant',
  },
  confirm_modal: {
    title: {
      fork: 'Transformă-l în propria categorie a acestui restaurant?',
      owned: 'Aplici noile rate?',
      reset: 'Reveniți la categoria moștenită?',
    },
    affected_one: '{{count}} produs sau categorie este în prezent asociat(ă) și va fi taxat(ă) cu noile rate.',
    affected_few: '{{count}} produse și categorii sunt legate în prezent și vor fi taxate cu noile cote.',
    affected_other: '{{count}} produse și categorii sunt în prezent asociate și vor fi taxate cu noile rate.',
    affected_settings_one: '{{count}} produs sau categorie este momentan asociat(ă) și va folosi setările actualizate.',
    affected_settings_few: '{{count}} produse și categorii sunt legate în prezent și vor folosi setările actualizate.',
    affected_settings_other:
      '{{count}} produse și categorii sunt momentan asociate și vor folosi setările actualizate.',
    restaurants_one: 'Acesta este {{count}} restaurant.',
    restaurants_few: 'Sunt {{count}} restaurante.',
    restaurants_other: 'Acestea sunt {{count}} restaurante.',
    acknowledge:
      'Înțeleg că, confirmând, se schimbă categoria de taxare pentru toate produsele asociate în prezent cu această categorie',
    impact_error: 'Nu s-a putut verifica ce produse ar fi afectate',
    cancel: 'Anulați',
    confirm: 'Confirmă',
  },
  toasts: {
    load_error: 'Nu s-au putut încărca categoriile fiscale.',
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
    delete_error: 'Nu s-a putut șterge această categorie fiscală.',
    category_deleted: 'Categoria fiscală a fost ștearsă',
    category_reset: 'Categoria de taxe a fost resetată la cea moștenită',
    reset_error: 'Nu s-a putut reseta această categorie de taxe.',
    impact_error: 'Nu s-a putut verifica ce produse ar fi afectate',
    impact_changed_one:
      'Numărul de produse afectate s-a schimbat la {{count}}. Te rugăm să verifici și să confirmi din nou.',
    impact_changed_few: 'Numărul produselor afectate s-a schimbat la {{count}}. Verifică și confirmă din nou.',
    impact_changed_other:
      'Numărul de produse afectate s-a schimbat la {{count}}. Te rugăm să verifici și să confirmi din nou.',
  },
};
